import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';

import Category from './Category';
import City from './City';
import Specialty from './Specialty';
import Sport from './Sport';
import Tags from './Tags';
import ChannelName from './ChannelName';
import Bio from './Bio';
import Website from './Website';

const Container = styled(Paper)`
  margin : 10px;
  padding: 15px 20px;
`
const FullWidthField = styled.div`
  width: 100%;
  margin-bottom: 20px;
`

const Channel = ({
  data,
  onSubmit,
  openChannelNameDialog,
  ...other
}) => (
  <Container {...other}>
    <FullWidthField>
      <ChannelName
        onSubmit={(newData, callback) => onSubmit({ channel_name: newData.channel_name }, callback)}
        data={data}/>
    </FullWidthField>
    <FullWidthField>
      <City
        onSubmit={(newData, callback) => onSubmit({ city: newData.city }, callback)}
        openChannelNameDialog={openChannelNameDialog}
        data={data}/>
    </FullWidthField>
    <FullWidthField>
      <Category
        onSubmit={(newData, callback) => onSubmit({ categories: newData.categories }, callback)}
        openChannelNameDialog={openChannelNameDialog}
        data={data}/>
    </FullWidthField>
    <FullWidthField>
      <Specialty
        onSubmit={(newData, callback) => onSubmit({ specialties: newData.specialties }, callback)}
        openChannelNameDialog={openChannelNameDialog}
        data={data}/>
    </FullWidthField>
    <FullWidthField>
      <Sport
        onSubmit={(newData, callback) => onSubmit({ sports: newData.sports }, callback)}
        openChannelNameDialog={openChannelNameDialog}
        data={data}
      />
    </FullWidthField>
    <FullWidthField>
      <Tags
        onSubmit={(newData, callback) => onSubmit({ tags: newData.tags }, callback)}
        openChannelNameDialog={openChannelNameDialog}
        data={data}/>
    </FullWidthField>
    <FullWidthField>
      <Bio
        onSubmit={(newData, callback) => onSubmit({ bio: newData.bio }, callback)}
        openChannelNameDialog={openChannelNameDialog}
        data={data}
        label="Bio"
        keyValue="bio1" />
    </FullWidthField>
    <FullWidthField>
      <Website
        onSubmit={(newData, callback) => onSubmit({ website: newData.website }, callback)}
        openChannelNameDialog={openChannelNameDialog}
        data={data} />
    </FullWidthField>
  </Container>
)

Channel.propTypes = {
  data: PropTypes.object,
  onSubmit: PropTypes.func,
};

Channel.defaultProps = {
  data: null,
};

export default Channel;
